import FileActions from '#redux/File/actions';
import ProductsActions from '#redux/Products/actions';
import { isEmpty } from '#utils/array';
import { isEmptyObject } from '#utils/object';

import { PRODUCT_PROPS_INCLUDING_FILE } from './constants';

const productAttachedFiles = product =>
  Object.keys(product)
    .filter(productKey => PRODUCT_PROPS_INCLUDING_FILE.includes(productKey))
    .reduce(
      (files, productKey) =>
        isEmptyObject(product[productKey])
          ? files
          : [...files, { file: product[productKey][0], urlKey: `${productKey}URL` }],
      []
    );

const customSectionsAttachedFiles = customSections =>
  customSections?.flatMap(customSection => {
    const { customSectionImage, id } = customSection;
    if (isEmptyObject(customSectionImage) || typeof customSectionImage === 'string') {
      return [];
    }
    return [{ file: customSection.customSectionImage[0], id }];
  });

const maturationsAttachedFiles = maturationNotes =>
  maturationNotes?.flatMap(maturationNote => {
    const { maturationFile, id } = maturationNote;
    if (isEmptyObject(maturationFile) || typeof maturationFile === 'string') {
      return [];
    }
    return [{ file: maturationNote.maturationFile[0], id }];
  });

const uploadFile = (file, dispatch, postUploadSuccessAction) => {
  dispatch(FileActions.getSignedUrl({ file, postUploadSuccessAction }));
};

const productRequest = (values, dispatch, actionType) => {
  dispatch(ProductsActions[actionType](values));
};

const makeProductAction = ({
  files,
  customSectionFiles,
  maturationFiles,
  dispatch,
  values,
  urls,
  actionType
}) => {
  if (isEmpty(files)) {
    if (isEmpty(customSectionFiles)) {
      if (isEmpty(maturationFiles)) {
        const orderedMaturationNotes = values.maturationNotes.sort((a, b) => a.id - b.id);
        const orderedCustomSections = values.customSections.sort((a, b) => a.id - b.id);
        productRequest(
          {
            ...values,
            ...urls,
            maturationNotes: orderedMaturationNotes,
            customSections: orderedCustomSections
          },
          dispatch,
          actionType
        );
      } else {
        const firstFile = maturationFiles.shift();
        const fileMaturationNote = values.maturationNotes.find(({ id }) => id === firstFile.id);
        const maturationNotesWithoutSelected = values.maturationNotes.filter(({ id }) => id !== firstFile.id);

        uploadFile(firstFile.file, dispatch, serverURL =>
          makeProductAction({
            files,
            dispatch,
            values: {
              ...values,
              maturationNotes: [
                ...maturationNotesWithoutSelected,
                { ...fileMaturationNote, maturationFile: serverURL }
              ]
            },
            customSectionFiles,
            maturationFiles,
            urls,
            actionType
          })
        );
      }
    } else {
      const firstFile = customSectionFiles.shift();
      const fileCustomSection = values.customSections.find(({ id }) => id === firstFile.id);
      const customSectionsWithoutSelected = values.customSections.filter(({ id }) => id !== firstFile.id);

      uploadFile(firstFile.file, dispatch, serverURL =>
        makeProductAction({
          files,
          dispatch,
          values: {
            ...values,
            customSections: [
              ...customSectionsWithoutSelected,
              { ...fileCustomSection, customSectionImage: serverURL }
            ]
          },
          customSectionFiles,
          maturationFiles,
          urls,
          actionType
        })
      );
    }
  } else {
    const firstFile = files.shift();

    uploadFile(firstFile.file, dispatch, serverURL =>
      makeProductAction({
        files,
        dispatch,
        values,
        urls: { ...urls, [firstFile.urlKey]: serverURL },
        actionType,
        customSectionFiles,
        maturationFiles
      })
    );
  }
};

export const uploadProductFilesThen = actionType => values => dispatch => {
  const files = productAttachedFiles(values);

  const customSectionFiles = customSectionsAttachedFiles(values.customSections);
  const maturationFiles = maturationsAttachedFiles(values.maturationNotes);
  const urls = {};

  const newValues = {
    ...values,
    customSections: values.customSections.map(customSection => ({
      ...customSection,
      customSectionImage:
        typeof customSection.customSectionImage === 'string' ? customSection.customSectionImage : ''
    })),
    maturationNotes: values.maturationNotes.map(maturationNote => ({
      ...maturationNote,
      maturationFile: typeof maturationNote.maturationFile === 'string' ? maturationNote.maturationFile : ''
    }))
  };

  makeProductAction({
    files,
    dispatch,
    values: newValues,
    urls,
    actionType,
    customSectionFiles,
    maturationFiles
  });
};
